interface FetchApiOptions {
  url?: string;
  method?: string;
  data?: any;
  keepalive?: boolean;
}

interface FetchApiConfig {
  catchErr?: boolean;
}

export async function fetchApi(
  { url = '', method = 'GET', data = {}, keepalive = false }: FetchApiOptions = {},
  { catchErr = false }: FetchApiConfig = {},
): Promise<any> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  try {
    const response = await fetch(url, {
      method,
      headers,
      body: method === 'GET' ? null : JSON.stringify(data),
      keepalive,
    });
    if (!response.ok) {
      // Extend Error to include status properties
      const error = new Error(`HTTP error! status: ${response.status}`) as Error & {
        status?: number;
        statusText?: string;
      };
      error.status = response.status;
      error.statusText = response.statusText;
      throw error;
    }

    const result = await response.json();
    return catchErr ? { result, res: result } : result;
  } catch (error) {
    if (!catchErr) throw error;
    console.error(error);
    return { err: error, error: error };
  }
}
